// extracted by mini-css-extract-plugin
export default {"wrapper":"ServiceOverview_wrapper__wSKxS","item":"ServiceOverview_item__+gV0D","value":"ServiceOverview_value__oIxXI"};